<template>
  <div class="left-box">
    <p class="title">产品中心</p>
    <div class="left-box-box">
      <div class="l-b-t">
        <Row>
          <Col span="8">
            <Menu
              :open-names="openName"
              :active-name="activeName"
              ref="side_menu"
              theme="light"
              width="auto"
              @on-open-change="viewpages"
              @on-select="viewPage" 
              accordion
            >
              <!-- 菜单开始，Menu-item是内容，template slot="title"是大标题 -->
              <template v-for="nav in navs">
                <Submenu
                  :name="nav.id"
                  :key="nav.key"
                  @click.native="getfourLevel(nav.description)"
                  v-if="nav.name"
                >
                  <!-- 一级菜单，slot="title"代表这里是标题 -->
                  <template slot="title">
                    <!-- 一级菜单标题 -->
                    <!-- <Icon type="ios-folder"
                    ></Icon>-->
                    <span class="layout-text">{{ nav.name }}</span>
                  </template>
                  <!-- 二级菜单 -->
                  <template v-for="child in nav.children">
                    <Menu-item
                      :name="child.id"
                      id="two"
                      @click.native="getfourLevel()"
                      :key="child.key"
                      v-if="!child.children"
                    >
                      <!-- 有三级导航的，配置的时候不要加id，这里用v-if="child.id"判断了一下，否则会出现二级菜单有两个三级菜单 -->
                      <!-- <Icon type="/project-info"></Icon> -->
                      <span class="layout-text">{{child.name}}</span>
                    </Menu-item>
                    <!-- 以下是三级菜单 -->
                    <Submenu
                      :name="child.id"
                      @click.native="getfourLevel()"
                      :key="child.key"
                      id="three"
                      v-if="child.children && child.children.length > 0"
                    >
                      <!-- 三级菜单标题 -->
                      <template slot="title">
                        <!-- <Icon type="ios-bowtie"
                        ></Icon>-->
                        <span class="layout-text">{{child.name}}</span>
                      </template>
                      <!-- 三级菜单内容 -->
                      <template v-for="son in child.children">
                        <Menu-item
                          :name="son.id"
                          :fourLevel="son.children"
                          @click.native="getfourLevel(son.children)"
                          :key="son.key"
                        >
                          <!-- <Icon type="md-book"
                          ></Icon>-->
                          <span class="layout-text">{{son.name}}</span>
                        </Menu-item>
                      </template>
                    </Submenu>
                  </template>
                </Submenu>
                <!-- 如果是无下拉导航走这里，通过有没有title来判断 -->
                <Menu-item :name="nav.id" :key="nav.key" v-if="!nav.name">
                  <!-- <Icon type="md-book"
                  ></Icon>-->
                  <span class="layout-text">{{nav.name}}</span>
                </Menu-item>
              </template>
            </Menu>
          </Col>
        </Row>
      </div>
      <div class="l-b-b">
        <div class="phone">
          <p>电话订购</p>
          <span>400-088-0777</span>
        </div>
        <div class="wechat">
          <div class="img">
            <img src="../../../images/1.jpg" alt />
          </div>
          <p>【扫一扫，微信订购】</p>
        </div>
        <div class="email">
          <p>邮件订购：</p>
          <span>订购邮箱<br>sales_me@bioleaper.com</span>
          <span>服务邮箱 <br>service_me@bioleaper.com</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navs: [],
      activeName: this.$route.query.opennames ? this.$route.query.opennames : '',
      openName: [],
      goodFlag:false
    };
  },
  methods: {
    viewpages(name) {
      this.getfourLevel("", undefined);
      if (name[1] !== undefined) {
        this.viewPage(name[1]);
      } else {
        if (name.length > 0) {
          this.$store.state.productLeftName = name[0];
          this.viewPage(name[0]);
        } else {
          var name = this.$store.state.productLeftName;
          this.viewPage(name);
        }
      }
    },
    viewPage(name) {
      this.$store.state.category_id = name;
      this.$store.state.pageIndex = 1;
      this.$api.productCenter
        .getShopData({
          category_id: name,
          page: this.$store.state.pageIndex,
          limit: this.$store.state.pageSize
        })
        .then(res => {
          const arr = res.data.items;
          this.$store.state.total = res.count;
          arr.forEach(item => {
            item.flag = false;
          });
          this.$store.state.productData = arr;
          this.$store.state.brandList = res.data.brand_list
          this.$store.state.currentBrandIndex = ""
          if(this.$route.query.opennames && this.goodFlag){
            this.getLeftActive(arr[0].goods_code)
            this.goodFlag = false
          }
        });
    },
    getLeftActive(code){
      this.$api.productCenter
      .goodsDetail({
        goods_code: code
      })
      .then(res => {
        var allId = res.data.category_path_id
        var numallId = allId.split(',')
        this.openName = numallId.map(Number)
        this.$nextTick(() => {
          this.$refs.side_menu.updateOpened();
        })
      })
    },
    getfourLevel(item) {
      this.$store.state.currentIndex = "four";
      if (item !== undefined) {
        this.$store.state.itemData = item;
      } else {
        this.$store.state.itemData = [];
      }
    }
  },
  created() {
    this.$api.productCenter
      .getproduct({
        rank: 0
      })
      .then(res => {
        this.navs = res.data;
       if(this.$route.query.opennames){
          this.viewPage(this.$route.query.opennames);
          this.getfourLevel('')
          this.goodFlag = true
        } else {
          var data = res.data
          this.$store.state.productLeftName = data[0].id
          this.viewPage(data[0].id)
          this.openName = [data[0].id]
          this.$nextTick(() => {
            this.$refs.side_menu.updateOpened()
          })
        }
    });
  }
};

</script>

<style lang="less" scoped>
.left-box {
  width: 313px;
  background: #003871;
  margin-top: 44px;
  margin-bottom: 20px;
  .title {
    width: 100%;
    height: 80px;
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    color: #ffbb00;
    padding-top: 25px;
    padding-left: 30px;
  }
  .left-box-box {
    width: 300px;
    span {
      cursor: pointer;
    }
    .l-b-t {
      width: 300px;
      background: #fafbfc;
      box-shadow: 0px 1px 0px 0px #e9eaeb;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .one-level {
        width: 100%;
        height: 100%;
      }
      /deep/#two{
          font-size: 16px;
          font-weight: 600;
          color: #333333
      }
      /deep/.ivu-menu-item:hover {
        color: #a52a2a !important;
      }
      /deep/.ivu-menu-submenu-title:hover {
        color: #a52a2a !important;
      }
      /deep/.ivu-row,
      .ivu-col-span-8,
      .ivu-menu-vertical {
        width: 100% !important;
      }
      /deep/ .ivu-menu-submenu-title {
        height: 50px;
        line-height: 25px;
        font-size: 16px;
        background: #fafbfc;
        color: #333333;
        font-weight: 600 !important;
      }
      /deep/ #three {
        .ivu-menu-submenu-title {
          background: #f5f6f8 !important;
        }
        .ivu-menu-item {
          background: #f0f2f5 !important;
          font-size: 16px;
          font-weight: 600;
          color: #333333;
        }
      }
      /deep/ .ivu-menu {
        background: #f5f6f8;
        /deep/ .ivu-menu-item {
          line-height: 100%;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 600 !important;
          color: #333333;
          font-size: 16px;
        }
      }
      /deep/.ivu-menu-item-selected {
        color: #a52a2a !important;
        background: #f5f6f8;
        z-index: 2;
      }
      /deep/ .ivu-menu-item-selected::after {
        background: #f5f6f8;
      }
      /deep/ .ivu-menu-submenu.ivu-menu-opened {
        p {
          color: #a52a2a;
        }
      }
      /deep/ .ivu-col-span-8 {
        background: #f5f6f8;
      }
    }
.l-b-b {
      opacity: 0.89;
      background: #fafbfc;
      min-width: 300px;
      min-height: 450px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;
      .phone {
        font-size: 16px;
        text-align: center;
        color: #333333;
        line-height: 36px;
        font-weight: bold;
        span{
          font-size: 22px;
        }
      }
      .wechat {
        .img {
          margin: auto;
          width: 134px;
          height: 134px;
          background: #ffffff;
          img {
            width: 118px;
            height: 118px;
            background: rgba(0, 0, 0, 0);
          }
        }
        p {
          font-weight: bold;
          font-size: 16px;
          color: #333333;
        }
      }
      .email {
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        p {
          font-weight: bold;
          font-size: 15px;
          text-align: center;
          color: #000;
        }
        span {
          font-size:15px;
          color: #000;
          margin-top: 13px;
        }
      }
    }
  }
}
.el-col,
.el-row {
  width: 100%;
}
</style>
